"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _ = require("../..");

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Sidebar = function Sidebar(_ref) {
  var open = _ref.open,
      setOpen = _ref.setOpen,
      classes = _ref.classes,
      children = _ref.children;
  return _react["default"].createElement("aside", {
    "aria-expanded": open
  }, _react["default"].createElement("div", {
    className: "".concat(open ? classes.open : classes.closed)
  }), _react["default"].createElement("div", {
    className: "".concat(classes.sidebar, " + ").concat(open ? classes.open : classes.closed)
  }, _react["default"].createElement("header", {
    className: classes.heading,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, _react["default"].createElement("div", {
    className: classes.icon
  }, _react["default"].createElement(_.Icon, {
    icon: "logo-white"
  })), _react["default"].createElement(_Typography["default"], {
    type: "logo"
  }, "Kangarootime")), _react["default"].createElement("nav", {
    className: classes.sidebarContent
  }, children)));
};

var _default = (0, _styles2.withStyles)(_styles.styles)(Sidebar);

exports["default"] = _default;